import {SHOW_EVENT, HIDE_EVENT} from './loader_interceptor';

export default class LoaderScreenController {
  constructor($rootScope) {
    'ngInject';
    this.loadingImage = require('../../img/loading.gif');
    $rootScope.$on(SHOW_EVENT, () => this.isLoading = true);
    $rootScope.$on(HIDE_EVENT, () => this.isLoading = false);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/loaderScreen/loaderScreen.controller.js